export default __webpack_public_path__ + "static/media/Work_Stress.b260eaa8.png";